module.exports = __webpack_public_path__ + "media/images/onb-terms_conditions-b19f374c.svg";